import React, { useState, useEffect } from "react";
import clsx from "clsx";
import RestaurantTable from "./components/RestaurantTable/RestaurantTable";
import PaymentTable from "./components/PaymentTable/PaymentTable";
import FeaturedTable from "./components/FeaturedTable/FeaturedTable";
import ReviewTable from "./components/ReviewTable/ReviewTable";
import EnquiriesTable from "./components/EnquiriesTable/EnquiriesTable";
import { getAllRestaurantsApi } from "./Api";
import "./RestaurantScreen.css";

const menus = ["Payments Due", "Featured", "Recent Reviews", "Enquiries"];

const RestaurantScreen = () => {
  const [storePreviousIndex, handlePreviousIndex] = useState(-11);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [allRestaurants, setAllRestaurants] = useState([]);

  useEffect(() => {
    getAllRestaurants();
    return () => {};
  }, [1]);

  const getAllRestaurants = async () => {
    const res = await getAllRestaurantsApi();
    console.log("Res is", res);
    if (!res.isError) {
      setAllRestaurants(res.data.data);
    }
  };

  console.log(allRestaurants);

  function handleActiveTab(e) {
    console.log(
      document
        .getElementById(storePreviousIndex)
        .classList.remove("menu-clicked")
    );
    switch (e.target.innerText) {
      case "All Restaurants": {
        setActiveTabIndex(1);
        console.log(e.target.id);
        document.getElementById(e.target.id).classList.add("menu-clicked");
        handlePreviousIndex(e.target.id);
        break;
      }
      case "Payments Due": {
        setActiveTabIndex(2);
        console.log(e.target.id);
        document.getElementById(e.target.id).classList.add("menu-clicked");
        handlePreviousIndex(e.target.id);
        break;
      }
      case "Featured": {
        setActiveTabIndex(3);
        console.log(e.target.id);
        document.getElementById(e.target.id).classList.add("menu-clicked");
        handlePreviousIndex(e.target.id);
        break;
      }
      case "Recent Reviews": {
        setActiveTabIndex(4);
        console.log(e.target.id);
        document.getElementById(e.target.id).classList.add("menu-clicked");
        handlePreviousIndex(e.target.id);
        break;
      }
      case "Enquiries": {
        setActiveTabIndex(5);
        console.log(e.target.id);
        document.getElementById(e.target.id).classList.add("menu-clicked");
        handlePreviousIndex(e.target.id);
        break;
      }
      default:
        setActiveTabIndex(1);
    }
  }

  return (
    <div className="restaurant-details">
      <ul>
        <li
          id="-11"
          onClick={(e) => handleActiveTab(e)}
          className="menu-clicked"
        >
          All Restaurants
        </li>
        {menus.map((menu, index) => (
          <li id={index + 1} onClick={(e) => handleActiveTab(e)}>
            {menu}
          </li>
        ))}
      </ul>

      {activeTabIndex == 1 && (
        <RestaurantTable allRestaurants={allRestaurants} />
      )}
      {activeTabIndex === 2 && <PaymentTable allRestaurants={allRestaurants} />}
      {activeTabIndex === 3 && (
        <FeaturedTable allRestaurants={allRestaurants} />
      )}
      {activeTabIndex === 4 && <ReviewTable allRestaurants={allRestaurants} />}
      {activeTabIndex === 5 && (
        <EnquiriesTable allRestaurants={allRestaurants} />
      )}
    </div>
  );
};

export default RestaurantScreen;

{
  /* <li
          onClick={() => setActiveTabIndex(1)}
          className={clsx("p-2 rounded-sm px-3  cursor-pointer", {
            ["bg-white "]: activeTabIndex == 1,
          })}
        >
          All Restaurants
        </li>
        <li
          onClick={() => setActiveTabIndex(2)}
          className={clsx("p-2 rounded-sm px-3 cursor-pointer", {
            ["bg-white"]: activeTabIndex == 2,
          })}
        >
          Payments Due
        </li>
        <li
          onClick={() => setActiveTabIndex(3)}
          className={clsx("p-2 rounded-sm px-3 cursor-pointer", {
            ["bg-white"]: activeTabIndex == 3,
          })}
        >
          Featured
        </li>
        <li
          onClick={() => setActiveTabIndex(4)}
          className={clsx("p-2 rounded-sm px-3 cursor-pointer", {
            ["bg-white"]: activeTabIndex == 4,
          })}
        >
          Recent Reviews
        </li>
        <li
          onClick={() => setActiveTabIndex(5)}
          className={clsx("p-2 rounded-sm px-3 cursor-pointer", {
            ["bg-white"]: activeTabIndex == 5,
          })}
        >
          Enquiries
        </li> */
}
